import { getCookie, setCookie } from "./cookies"
import { USER_OBJECT_COOKIE } from "./constants"

export const updateUserCookie = (data: any) => {
  const userObj: any = getCookie(USER_OBJECT_COOKIE)
  const user = userObj ? { ...JSON.parse(userObj), ...data } : { ...data }

  setCookie(USER_OBJECT_COOKIE, JSON.stringify(user), {
    sameSite: "lax",
    path: process.env.NEXT_PUBLIC_ASSET_PREFIX || "/",
  })
}
